import { NumberParam, StringParam } from "use-query-params";

// search params config
export const queryParamsConfig = {
  search: StringParam,
  limit: NumberParam,
};

export const initialFilter = {
  limit: 100,
};
